import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

interface PieChartData {
    name: string;
    value: number;
    color: string;
}

interface PieChartCardProps {
    title: string;
    data: PieChartData[];
    loading?: boolean;
}

const PieChartCard: React.FC<PieChartCardProps> = ({ title, data, loading }) => {
    // Filtrar dados com valor zero
    const filteredData = data.filter(d => d.value > 0);

    // Se não há dados, mostrar mensagem
    if (!loading && filteredData.length === 0) {
        return (
            <div className="bg-white rounded-xl shadow p-6 h-80 flex flex-col">
                <h3 className="text-lg font-bold mb-4">{title}</h3>
                <div className="flex-1 flex items-center justify-center text-gray-400">
                    Sem dados disponíveis
                </div>
            </div>
        );
    }

    const total = filteredData.reduce((sum, d) => sum + d.value, 0);

    return (
        <div className="bg-white rounded-xl shadow p-6 h-80 flex flex-col">
            <h3 className="text-lg font-bold mb-4">{title}</h3>
            {loading ? (
                <div className="w-full h-full bg-gray-100 animate-pulse rounded-lg" />
            ) : (
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={filteredData}
                            cx="50%"
                            cy="50%"
                            innerRadius={40}
                            outerRadius={70}
                            paddingAngle={2}
                            dataKey="value"
                            label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                            labelLine={false}
                        >
                            {filteredData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                        <Tooltip
                            formatter={(value: number, name: string) => [
                                `${value} (${((value / total) * 100).toFixed(1)}%)`,
                                name
                            ]}
                        />
                        <Legend
                            verticalAlign="bottom"
                            height={36}
                            formatter={(value, entry) => (
                                <span style={{ color: entry.color, marginRight: 10 }}>{value}</span>
                            )}
                        />
                    </PieChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};

export default PieChartCard;
